/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import cn from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
// Components
import Button from '../newButton/Button'
import PuppyCard from '../newPuppyCard/puppyCard'
import useRelatedBreeds from '@/hooks/useRelatedBreeds'
import styles from './OtherDogs.module.scss'

const SwiperButton = ({ onClick, disabled, direction }) => (
  <button
    className={cn({
      [styles.swiperButton]: true,
      [styles[`swiper${direction}`]]: !disabled,
      [styles[`disabled${direction}`]]: disabled,
    })}
    onClick={onClick}
  />
)

export default function OtherDogs({
  breedId,
  breedDogs,
  favourites,
  updateFavourite,
  isMobile,
}) {
  const ref = useRef(null)
  const { relatedBreeds, isLoading } = useRelatedBreeds(breedId)
  const router = useRouter()

  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)
  const [selectedBreeds, setSelectedBreeds] = useState({})
  const [filteredBreeds, setFilteredBreeds] = useState([])
  const [tabs, setTabs] = useState([])

  const MAX_BREEDS = 3

  useEffect(() => {
    if (!isLoading) {
      // Filter out breeds without dogs
      const breedsWithDogs = relatedBreeds
        ?.filter((breed) => breed.dogs && breed.dogs.length > 0)
        ?.slice(0, MAX_BREEDS)

      setTabs([breedDogs, ...breedsWithDogs])
      setFilteredBreeds([breedDogs, ...breedsWithDogs])
    }
  }, [relatedBreeds, isLoading])

  /* Swiper Handlers   */
  const goNext = async () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      await ref.current.swiper.slideNext()
      setIsBeginning(ref.current?.swiper?.isBeginning)
      setIsEnd(ref.current?.swiper?.isEnd)
    }
  }

  const goPrev = async () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      await ref.current.swiper.slidePrev()
      setIsBeginning(ref.current?.swiper?.isBeginning)
      setIsEnd(ref.current?.swiper?.isEnd)
    }
  }

  if (!relatedBreeds.length) {
    return (
      <section className={styles.otherDogs}>
        <Button
          title="View all puppies"
          onClick={() => router.push('/search')}
          theme={['medium', 'pink-solid']}
          style={{
            width: '250px',
            margin: '0 auto',
            marginTop: isMobile ? '40px' : '90px',
            marginBottom: isMobile ? '0px' : '90px',
          }}
        />
      </section>
    )
  }

  return (
    <section className={styles.otherDogs}>
      <div className={styles.title}>
        <h2>Related Puppies</h2>
        <div className={cn(styles.button, styles.titleButton)}>
          <Link href={`/search?breed=${breedId}`}>View All</Link>
        </div>
      </div>

      <div className={styles.actions}>
        <div className={styles.tags}>
          {tabs?.map((breed) => (
            <div
              key={breed.id}
              className={cn(
                styles.tag,
                selectedBreeds[breed.id] ? styles.active : styles.inactive,
              )}
              onClick={() => {
                setSelectedBreeds({ [breed?.id]: true })
                setFilteredBreeds([breed])
              }}
            >
              {selectedBreeds[breed.id] ? (
                <div className={styles.icon} />
              ) : null}
              <p>{breed?.name}</p>
            </div>
          ))}
        </div>
        <div className={cn(styles.button, styles.actionButton)}>
          <Link href={`/search?breed=${breedId}`}>View All</Link>
          <SwiperButton
            direction="Prev"
            disabled={isBeginning}
            onClick={goPrev}
          />
          <SwiperButton direction="Next" disabled={isEnd} onClick={goNext} />
        </div>
      </div>

      <div className={styles.cards}>
        <Swiper
          speed={1000}
          grabCursor
          breakpoints={{
            320: {
              slidesPerView: 2,
              spaceBetween: -20,
            },
            960: {
              slidesPerView: 2,
              spaceBetween: 5,
            },
            1085: {
              slidesPerView: 4,
              spaceBetween: 5,
            },
            1585: {
              slidesPerView: 5,
              spaceBetween: 5,
            },
            1900: {
              slidesPerView: 6,
              spaceBetween: 5,
            },
          }}
          ref={ref}
        >
          {filteredBreeds?.map((breed) =>
            breed?.dogs?.map((dog, i) => (
              <SwiperSlide key={i}>
                <PuppyCard
                  dog={dog}
                  isFavourite={
                    !!favourites.filter((d) => d.id === dog.id).length
                  }
                  updateFavourite={() => updateFavourite(dog.id)}
                />
              </SwiperSlide>
            )),
          )}
        </Swiper>
      </div>
    </section>
  )
}
